import React, {useState} from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {getHeaders, getMPPEndpoint} from '../../../../helpers/endpoint';

const CHAMPIONSHIP_ID = 8;
const SEASON = 2025;

const updateMatchsQuotationsAction = (onSuccess, onError) => {
  return (_dispatch, getState) => {
    fetch(getMPPEndpoint('updateMatchsQuotations'), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({
        championshipId: CHAMPIONSHIP_ID,
        season: SEASON,
      }),
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(
            data => {
              throw new Error(data.error || `Error ${response.status}`);
            },
            () => {
              throw new Error(`Error ${response.status}`);
            },
          );
        }
        return response.json();
      })
      .then(data => {
        onSuccess(data);
      })
      .catch(error => {
        onError && onError(error);
      });
  };
};

const MPPUpdateQuotations = ({dispatch}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);

    dispatch(
      updateMatchsQuotationsAction(
        () => {
          setIsLoading(false);
          swal({
            title: 'Success!',
            text: 'Match quotations updated correctly.',
            type: 'success',
          });
        },
        error => {
          setIsLoading(false);
          swal({
            title: 'Error!',
            text: `Something went wrong: ${error.message || error}`,
            type: 'error',
          });
        },
      ),
    );
  };

  return (
    <div style={{margin: '20px'}}>
      <button
        id="mpp-update-quotations-btn"
        className="btn btn-primary"
        onClick={handleClick}
        disabled={isLoading}>
        {isLoading && (
          <i className="fa fa-spinner fa-spin" style={{marginRight: '8px'}} />
        )}
        MAJ des côtes des matchs
      </button>
    </div>
  );
};

export default connect()(MPPUpdateQuotations);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/DashboardTools/MPPUpdateQuotations.js